import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { HashRouter as Router } from "react-router-dom"
import history from "./utils/history"
import { ConfigProvider } from "antd"
import "moment/locale/zh-cn"
import locale from "antd/es/locale/zh_CN"
import enUS from "antd/es/locale/en_US"
import "./styles/index.less"
import {createQQmapScripit} from "@/utils/qqmap.js"
import "./i18n"  // 引入国际化配置

// useEffect(() => {
// //创建腾讯地图script
// 
// },[])
createQQmapScripit()

// 获取当前语言
const currentLang = localStorage.getItem('i18nextLng') || 'zh-CN';
const antdLocale = currentLang === 'zh-CN' ? locale : enUS;

ReactDOM.render(
    <Router>
        <ConfigProvider locale={antdLocale}>
            <App {...history} />
        </ConfigProvider>
    </Router>,
    document.getElementById("root")
)
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
        registration.unregister()
    })
}
